/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardMetricsResponse { 
    totalEquipmentCount: number;
    activeEquipmentCount: number;
    totalHashrate: number;
    totalSolHashrate: number;
    totalPower: number;
    freePower: number;
    averageTemperature: number;
}

